import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NotFound: React.FC = () => (
  <div className="min-h-screen bg-[#000000] text-white flex flex-col">
    <Helmet>
      <title>Page Not Found | AmmoPantryAI</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
    <Header />
    <div className="flex-1 flex items-center justify-center px-4 py-20">
      <div className="text-center max-w-md">
        <p className="text-xs font-bold uppercase tracking-widest text-[#3b82f6] mb-4">404</p>
        <h1 className="text-5xl font-extrabold text-white mb-4">Page Not Found</h1>
        <p className="text-[#a3a3a3] text-lg mb-10">
          This page doesn't exist. Your inventory data is still safe on your device.
        </p>
        <Link
          to="/"
          className="inline-block bg-[#3b82f6] hover:bg-[#2563eb] text-white font-semibold px-8 py-4 rounded-xl transition-colors"
        >
          Back to Home
        </Link>
      </div>
    </div>
    <Footer />
  </div>
);

export default NotFound;
